/*
 * @Author: tangke
 * @Date: 2019-02-22 16:45:54
 * @Last Modified by: others
 * @Last Modified time: 2019-03-07 15:18:15
 * @课程详情页面下具体课程对应日历
 */
 <template>
  <v-card flat
          color="transparent"
>
    <v-card-title primary-title
                  color="white"
                  class="px-0 py-2">
      <div class="blue-title">Textbooks Note : You can update the material by yourself. Just click the material you intend to finish.</div>
      <v-spacer></v-spacer>
      <div>
        <v-chip color="transparent"
                class="black--text textbooks-tips"
                disabled
                v-for="(item,index) in ['Confirmed','Unfinished','Test']"
                :key="'state'+index">
          <v-icon :color="getColor(item)">stop</v-icon>
          {{item}}
        </v-chip>
      </div>
    </v-card-title>
    <v-card-text class="px-0">
      <v-expansion-panel class="class-detail-expansion-panel">
        <v-expansion-panel-content>
          <v-icon slot="actions"
                  color="primary">$vuetify.icons.expand</v-icon>
          <div slot="header">
                      <v-layout
            align-center
            fill-height
            justify-end
            row
          >
            <v-flex>
              <span class="class-detail-icon"></span><h2 class="blue-title">{{userCatagory.CategoryName || 'Teaching Materials'}}</h2>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn
                flat
                small
                v-for="(note, index) in userCatagory.TeachingNotes.split('|').filter(str => str.length)"
                :key="index"
                @click.stop="getTeachingNote(note)" class="teaching-notes"
              >
                <v-icon small>help</v-icon>Teaching Notes {{index + 1 | romanize}}
              </v-btn>
            </v-flex>
          </v-layout>
          </div>
          <v-card class="pl-2 pb-3">
            <!-- 需要替换为课表组件 -->
            <list></list>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-card-text>
  </v-card>
</template>

<script>
import list from './teachingMaterialList'
import { createNamespacedHelpers } from 'vuex'

const namespace = 'classDetail'
const { mapGetters } = createNamespacedHelpers(namespace)
export default {
  name: 'classDetailCalendar',
  data: () => ({
    materialStateColor: {
      Confirmed: 'teal darken-2',
      Unfinished: 'grey darken-2',
      Test: 'deep-orange darken-2'
    }
  }),
  filters: {
    romanize (num) {
      var lookup = { M: 1000, CM: 900, D: 500, CD: 400, C: 100, XC: 90, L: 50, XL: 40, X: 10, IX: 9, V: 5, IV: 4, I: 1 }
      var roman = ''
      var i
      for (i in lookup) {
        while (num >= lookup[i]) {
          roman += i
          num -= lookup[i]
        }
      }
      return roman
    }
  },
  components: { list },
  methods: {
    getColor (item) {
      return this.materialStateColor[item]
    },
    getTeachingNote (note) {
      this.$store.dispatch('downloadFile', { directory: 'TeachingMaterial', path: note })
    }
  },
  computed: {
    ...mapGetters(['userCatagory'])
  }
}
</script>
<style scoped lang="scss">
.class-detail-expansion-panel{
  box-shadow: 0px 0px 10px rgba(125, 162, 255, 0.19);
    border-radius: 8px;
}
.class-detail-icon{
  background: url(../../assets/img/class/teaching-material-icon.png) no-repeat center;
  width: 20px;
  height: 20px;
  display: block;
  float: left;
  margin-top: 5px;
  margin-right: 10px;
}
.v-expansion-panel__header__icon i{
  color: rgba(62, 103, 251, 0.2)!important;
  font-size: 30px;
}
.theme--light.v-expansion-panel .v-expansion-panel__container{
    @include bg_color($background-color-theme);

}
[data-theme="theme1"] .textbooks-tips{
  color: #ececec!important;
}
[data-theme="theme1"] .teaching-notes{
  color: #ececec!important;
}
</style>
